import { IS_PHYSICAL_OPTION } from 'domain/shared/leave';
import { FieldProps, useFieldHelper, EnumField } from 'framework/ui/field';

const SignatureOptionField = (props: FieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);

  return <EnumField label={getLabel()} value={getValue()} options={IS_PHYSICAL_OPTION} />;
};

export default SignatureOptionField;
